import React, { useState } from 'react';
import { getData, deleteData } from '../../../services/apiService';
import {
  Avatar, Badge, Box, Paper, Typography,
  Button, Menu, MenuItem, ListItemIcon, ListItemText,
  TableContainer, Table, TableHead, TableBody, TableRow, TableCell,
  Divider, Container,
} from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import NotificationsIcon from "@mui/icons-material/Notifications";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuIcon from "@mui/icons-material/Menu";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LockResetIcon from "@mui/icons-material/LockReset";
// import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
// import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useNavigate, } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import useAutoLogout from '../../../hooks/useAutoLogout';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { IconButton, Modal, useMediaQuery, useTheme, } from "@mui/material";
import { Link } from 'react-router-dom';
// import DataNotFound from '../../DataNotFound'

const PaymentDetails = ({ open, onClose, data, removeCartDetails, navigate }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));

  // Calculate total amount from API data
  const totalAmount = data.reduce((sum, item) => {
    const amount = parseFloat(item.course?.amount) || 0;
    return sum + amount;
  }, 0);

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box
        sx={{
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          width: isXs ? '95%' : isSm ? '80%' : isMd ? '70%' : '628px', maxWidth: '628px', maxHeight: '90vh', overflowY: 'auto',
          bgcolor: 'background.paper', boxShadow: 24, p: isXs ? 2 : isSm ? 3 : 4, borderRadius: 2,
        }} >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography variant={isXs ? "h6" : "h5"}>Checkout Details</Typography>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize={isXs ? "small" : "medium"} />
          </IconButton>
        </Box>

        {Array.isArray(data) && data.length > 0 ? (
          <Box>
            <TableContainer component={Paper} elevation={0} sx={{ mb: 2, borderRadius: 2, boxShadow: 2, overflow: 'hidden' }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: '#4B49AC' }}>
                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopLeftRadius: 8 }}>
                      Student
                    </TableCell>
                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}>
                      Course
                    </TableCell>
                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}>
                      Amount
                    </TableCell>
                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopRightRadius: 8 }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((item) => (
                    <TableRow key={item._id}>
                      <TableCell align="center">
                        <Typography variant="body1">{item.studentOrInstitut?.firstName || 'N/A'}</Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body1">{item.course?.courseName || 'N/A'}</Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body1">Rs {item.course?.amount || '0'}</Typography>
                      </TableCell>
                      <TableCell align="center">
                        <IconButton color="error" size="small">
                          <DeleteOutlineIcon fontSize="small" onClick={() => removeCartDetails(item._id)} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 3 }}>
              <Typography variant="h6">
                Total: Rs {totalAmount.toLocaleString()}
              </Typography>
              <Button onClick={() => {
                onClose();
                navigate("/Payment", { state: { cartData: data, totalAmount: totalAmount } });
              }} variant="contained" sx={{
                borderRadius: 2, fontWeight: 600, boxShadow: 2, px: 3, py: 1, textTransform: 'none', backgroundColor: '#4B49AC',
                '&:hover': { backgroundColor: '#3A3897' },
              }} >
                Checkout
              </Button>
            </Box>
          </Box>
        ) : (
          // <DataNotFound />
          <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", width: "100%", bgcolor: "#ffffff", }} data-model-id="548:1002">
            <Container maxWidth="lg" sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80%", }}>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "30px", maxWidth: "500px", textAlign: "center", }}>
                <Box component="img" src="/image/notDataFound.png" alt="404 Error Illustration" sx={{ width: "50%", height: "auto", maxHeight: "500px", objectFit: "cover", }} />
              </Box>
            </Container>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

const CustomMenuItem = ({ icon, text }) => (
  <MenuItem sx={{ py: 1.5, px: 2 }}>
    <ListItemIcon sx={{ minWidth: 40 }}>
      {icon}
    </ListItemIcon>
    <ListItemText>
      <Typography fontFamily="Poppins" fontSize={14} color="#4F4F4F">
        {text}
      </Typography>
    </ListItemText>
  </MenuItem>
);

const Header = ({ handleDrawerToggle }) => {
  const [data, setData] = useState([]);
  const { logout } = useAuth();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

  // get cart data 
  const paymentCheckout = async () => {
    try {
      const response = await getData(`/payment-checkout`);
      if (response) {
        setData(response);
      }
    } catch (error) {
      console.error('Failed to fetch data', error);
    }
  };

  // Remove cart data 
  const removeCartDetails = async (id) => {
    try {
      await deleteData(`/remove-cart-details/${id}`);
      paymentCheckout();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  useAutoLogout(handleLogout, 60 * 60 * 1000);

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCartClick = () => {
    setIsPaymentModalOpen(true);
  };

  const handlePaymentModalClose = () => {
    setIsPaymentModalOpen(false);
  };

  return (
    <Paper elevation={1} sx={{ height: 70, display: "flex", alignItems: "center", justifyContent: "space-between", px: 2, position: "sticky", top: 0, zIndex: 1, }} >
      <Box sx={{ display: "flex", alignItems: "center", width: '100%' }}>
        <Button onClick={handleDrawerToggle}
          sx={{
            minWidth: 'auto', p: 1, mr: 1, border: '1px solid #e0e0e0', borderRadius: '4px',
            '&:hover': { backgroundColor: 'action.hover', },
          }}>
          <MenuIcon />
        </Button>
        {/* <Autocomplete freeSolo options={[]} sx={{ flexGrow: 1, maxWidth: 700 }} renderInput={(params) => (
          <TextField {...params} placeholder="Search" variant="outlined" size="small"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }} sx={{ bgcolor: "neutral.50", borderRadius: 1 }}
          />
        )}
        /> */}
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {user?.role_id?.role_name === 'Institution' && (
          <Badge color="error" overlap="circular" anchorOrigin={{ vertical: "top", horizontal: "right" }}>
            <IconButton onClick={() => { paymentCheckout(); handleCartClick(); }}>
              <ShoppingCartCheckoutIcon />
            </IconButton>
          </Badge>
        )}

        {/* variant="dot"  dot icon class */}

        {/* <Badge variant="dot" color="error" overlap="circular" anchorOrigin={{ vertical: "top", horizontal: "right", }}>
          <NotificationsIcon />
        </Badge> */}

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, cursor: 'pointer' }} onClick={handleProfileClick} >
          <Avatar sx={{ bgcolor: "#14863a", width: 45, height: 45, border: "2px solid white", fontWeight: 800, }}>
            {user?.firstName?.charAt(0)}
          </Avatar>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body1" fontWeight={500}>
              {user?.firstName}
            </Typography>
            <ArrowDropDownIcon fontSize="small" />
          </Box>
        </Box>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}
          PaperProps={{
            elevation: 3,
            sx: {
              width: 262,
              borderRadius: "8px",
              overflow: "hidden",
              mt: 2,
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }} >
          <Box p={2} display="flex" alignItems="center" bgcolor="#FFFFFF">
            <Avatar sx={{ width: 48, height: 48, bgcolor: "#14863a" }}>
              {user?.firstName?.charAt(0)}
            </Avatar>
            <Box ml={1.5}>
              <Typography fontFamily="Poppins" fontSize={16} fontWeight={600}>
                {user?.firstName}
              </Typography>
              <Typography fontFamily="Poppins" fontSize={12} color="#2F80ED">
                {user?.email}
              </Typography>
            </Box>
          </Box>
          <Divider />

          {user?.role_id?.role_name === "Institution" ? (
            <Link to="/institute-profile" style={{ textDecoration: 'none' }}>
              <CustomMenuItem icon={<PersonOutlineOutlinedIcon />} text="View Profile" />
            </Link>
          ) : user?.role_id?.role_name === "Students" ? (
            <Link to="/student-profile" style={{ textDecoration: 'none' }}>
              <CustomMenuItem icon={<PersonOutlineOutlinedIcon />} text="View Profile" />
            </Link>
          ) : user?.role_id?.role_name === "Instructors" ? (
            <Link to="/instructor-profile" style={{ textDecoration: 'none' }}>
              <CustomMenuItem icon={<PersonOutlineOutlinedIcon />} text="View Profile" />
            </Link>
          ) : null}
          <Link to="/change-password" style={{ textDecoration: 'none' }}>
            <CustomMenuItem icon={<LockResetIcon  />} text="Change Password" />
          </Link>
          {/* <CustomMenuItem icon={<CreditCardOutlinedIcon />} text="Billing & Payments" />
          <CustomMenuItem icon={<SettingsOutlinedIcon />} text="Setting" /> */}
          <Divider />
          <Box p={2}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<LogoutOutlinedIcon />}
              onClick={handleLogout}
              sx={{
                color: '#EB5757',
                borderColor: '#EB5757',
                textTransform: 'none',
                fontFamily: 'Poppins',
                fontSize: 14,
                fontWeight: 500,
                '&:hover': {
                  borderColor: '#EB5757',
                  backgroundColor: 'rgba(235, 87, 87, 0.04)',
                },
              }}
            >
              Logout
            </Button>
          </Box>
        </Menu>
      </Box>

      <PaymentDetails open={isPaymentModalOpen} onClose={handlePaymentModalClose}
        data={data} removeCartDetails={removeCartDetails} navigate={navigate} />
    </Paper>
  );
};

export default Header;